import { useState } from 'react';

const CUBE_COLOR_THEMES = {
  navy: { top: '#000060', left: '#000040', right: '#000050' },
  blue: { top: '#3b5d9d', left: '#1b3d7d', right: '#2b4d8d' },
  none: { top: '#e7e9ed70', left: '#e7e9ed70', right: '#ffffff8a', bottom: '#d9e0ee70' }
};

export default function Cube({ element, rowIndex, itemIndex, onCubeClick, isActive, cubeId, dataAos, dataAosDuration, dataAosDelay, dataAosAnchorPlacement }) {
  const [angleY, setAngleY] = useState(0);
  const theme = CUBE_COLOR_THEMES[element.theme];
  const anchorName = `--cube-${itemIndex}-${rowIndex}`

  const handleClick = (e) => {
    const newAngle = angleY + 90;
    setAngleY(newAngle);
    
    // Get cube wrapper position
    const cubeWrapper = e.currentTarget;
    const rect = cubeWrapper.getBoundingClientRect();
    
    onCubeClick({
      infoKey: element.info_key,
      cubePosition: {
        x: rect.left + rect.width / 2,  // Center X
        y: rect.top,                     // Top Y
        width: rect.width,
        height: rect.height,
      },
      anchorName: anchorName,
      cubeId: cubeId
    });
  };

  const baseZIndex = 10 + rowIndex + itemIndex;
  const zIndex = isActive ? baseZIndex + 100 : baseZIndex;
  const isNoHover = element.theme === 'none';

  const faceStyles = {
    front: { background: theme.left },
    back: { background: theme.left },
    right: { background: theme.right },
    left: { background: theme.right },
    top: { background: theme.top },
    bottom: { background: theme.top }
  };

  return (
    <div
      style={{ zIndex }}
      {...(dataAos ? {
        'data-aos': dataAos,
        'data-aos-duration': dataAosDuration,
        'data-aos-delay': dataAosDelay,
        'data-aos-once': 'false',
        'data-aos-anchor-placement': dataAosAnchorPlacement,
      } : {})}
      className='cube-anim-wrapper'
    >
      <div
        className={`cube-wrapper ${isNoHover ? 'cube-wrapper--no-hover' : ''} ${isActive ? 'active' : ''}`}
        style={{ anchorName }}
        onClick={handleClick}
        data-cube-wrapper="true"
      >
        <div
          className="cube"
          style={{ '--add-y': `${angleY}deg` }}
        >
          <div className="face face--front" style={faceStyles.front}></div>
          <div className="face face--back" style={faceStyles.back}></div>
          <div className="face face--right" style={faceStyles.right}></div>
          <div className="face face--left" style={faceStyles.left}></div>
          <div className="face face--top" style={faceStyles.top}></div>
          <div className="face face--bottom" style={faceStyles.bottom}></div>
        </div>

        {element.icon && (
          <>
            <div className="cube-icon-background"></div>
            <img
              className="cube-icon"
              src={`/icons/${element.icon}.svg`}
              alt={element.icon}
            />
          </>
        )}
      </div>
    </div>
  );
}
